// ----------------------------------------------------------------------

const ROOTS = {
  DASHBOARD: '/v2/dashboard',
};

// ----------------------------------------------------------------------

export const paths = {
  dashboard: {
    root: ROOTS.DASHBOARD,
    users: {
      root: `${ROOTS.DASHBOARD}/users`,
      details: (id: string) => `${ROOTS.DASHBOARD}/users/${id}`,
    },
    clients: {
      root: `${ROOTS.DASHBOARD}/clients`,
      details: (id: string) => `${ROOTS.DASHBOARD}/clients/${id}`,
    },
    events: {
      root: `${ROOTS.DASHBOARD}/events`,
      details: (id: string) => `${ROOTS.DASHBOARD}/events/${id}`,
    },
    bookings: {
      root: `${ROOTS.DASHBOARD}/bookings`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/bookings/${id}/${client_id}`,
    },
    shipments: {
      root: `${ROOTS.DASHBOARD}/shipments`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/shipments/${id}/${client_id}`,
    },
    fleet: {
      root: `${ROOTS.DASHBOARD}/fleet`,
    },
    contracts: {
      root: `${ROOTS.DASHBOARD}/contracts`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/contracts/${id}/${client_id}`,
    },
    quotations: {
      root: `${ROOTS.DASHBOARD}/quotations`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/quotations/${id}/${client_id}`,
    },
    quoteRequests: {
      root: `${ROOTS.DASHBOARD}/quoteRequests`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/quoteRequests/${id}/${client_id}`,
    },
    orders: {
      root: `${ROOTS.DASHBOARD}/orders`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/orders/${id}/${client_id}`,
    },
    emissionReports: {
      all: `${ROOTS.DASHBOARD}/emission-reports/all`,
      completed: `${ROOTS.DASHBOARD}/emission-reports/completed`,
      processing: `${ROOTS.DASHBOARD}/emission-reports/processing`,
      failed: `${ROOTS.DASHBOARD}/emission-reports/failed`,
      orphaned: `${ROOTS.DASHBOARD}/emission-reports/orphaned`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/emission-reports/${id}/${client_id}`,
    },
    releaseNotes: {
      root: `${ROOTS.DASHBOARD}/release-notes`,
      details: (id: string) => `${ROOTS.DASHBOARD}/release-notes/${id}`,
      new: `${ROOTS.DASHBOARD}/release-notes/new`,
    },
    maintenance: {
      root: `${ROOTS.DASHBOARD}/maintenance`,
    },
    features: {
      root: `${ROOTS.DASHBOARD}/features`,
    },
    termsAndConditions: {
      root: `${ROOTS.DASHBOARD}/terms-and-conditions`,
      details: (id: string) => `${ROOTS.DASHBOARD}/terms-and-conditions/${id}`,
      new: `${ROOTS.DASHBOARD}/terms-and-conditions/new`,
    },
    clientsAPI: {
      root: `${ROOTS.DASHBOARD}/client-api`,
      details: (id: string) => `${ROOTS.DASHBOARD}/client-api/${id}`,
    },
    biReports: {
      root: `${ROOTS.DASHBOARD}/bi-reports`,
      details: (id: string) => `${ROOTS.DASHBOARD}/bi-reports/${id}`,
    },
    ratings: {
      root: `${ROOTS.DASHBOARD}/ratings`,
    },
    nonConformities: {
      root: `${ROOTS.DASHBOARD}/non-conformities`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/non-conformities/${id}/${client_id}`,
    },
    locations: {
      root: `${ROOTS.DASHBOARD}/locations`,
      details: (id: string) => `${ROOTS.DASHBOARD}/locations/${id}`,
    },
    addresses: {
      root: `${ROOTS.DASHBOARD}/addresses`,
      details: (id: string, client_id: string) =>
        `${ROOTS.DASHBOARD}/addresses/${id}/${client_id}`,
    },
    aiExperiments: {
      root: `${ROOTS.DASHBOARD}/ai-experiments`,
      mailClassification: {
        root: `${ROOTS.DASHBOARD}/ai-experiments/mail-classification`,
        details: (id: string) =>
          `${ROOTS.DASHBOARD}/ai-experiments/mail-classification/${id}`,
      },
    },
    mailAutomation: {
      root: '/v2/mail-automation',
      scrapedEmails: {
        root: `${ROOTS.DASHBOARD}/mail-automation/scraped-emails`,
        details: (id: string) =>
          `${ROOTS.DASHBOARD}/mail-automation/scraped-emails/${id}`,
      },
      processedEmails: {
        root: `${ROOTS.DASHBOARD}/mail-automation/processed-emails`,
        mailbox: (mailboxAddress: string) =>
          `${
            ROOTS.DASHBOARD
          }/mail-automation/processed-emails/${encodeURIComponent(
            mailboxAddress,
          )}`,
        details: (id: string) =>
          `${ROOTS.DASHBOARD}/mail-automation/processed-emails/detail/${id}`,
      },
      workflows: {
        root: '/v2/mail-automation/workflows',
        workflow: (workflowId: string) =>
          `/v2/mail-automation/workflows/${encodeURIComponent(workflowId)}`,
        workflowVersion: (workflowId: string, version: number) =>
          `/v2/mail-automation/workflows/${encodeURIComponent(
            workflowId,
          )}/versions/${version}`,
      },
      workflowRuns: {
        root: '/v2/mail-automation/workflow-runs',
        workflowRun: (workflowRunId: string) =>
          `/v2/mail-automation/workflow-runs/${encodeURIComponent(
            workflowRunId,
          )}`,
      },
      imageFingerprints: {
        root: '/v2/mail-automation/ignored-images',
      },
      settings: {
        root: '/v2/mail-automation/settings',
      },
    },
  },
};
